import jsonToolsActionTypes from "./json-tools.type";

const INITIAL_STATE = {
    SysPass: "Meet",
    Name: "Meet",
    IP: "123",
    Interval: "",
    Enabled: false,
    API: "",
    Type: "",
    Port: "",
};

const jsonToolsReducer = (state = INITIAL_STATE, action) => {
    switch (action.type) {
        case jsonToolsActionTypes.SET_JSON_TOOL_VALUES:
            return {
                ...state,
                [action.payloadKey]: action.payloadValue
            };
        case jsonToolsActionTypes.REMOVE_JSON_TOOL_VALUES:
            return {
                SysPass: "",
                Name: "",
                IP: "",
                Interval: "",
                Enabled: null,
                API: "",
                Type: "",
                Port: "",
            };
        case jsonToolsActionTypes.SIGNOUT_SUCCESS:
            return {
                SysPass: "",
                Name: "",
                IP: "",
                Interval: "",
                Enabled: null,
                API: "",
                Type: "",
                Port: "",
            };
        default:
            return state;
    }
};

export default jsonToolsReducer;
